import api from "../../../../../api";

export const requestGetPartOffer = (params) => {
    const queryString = `?limit=${params.limit}&offset=${params.offset}`;
    return api.get('/partoffersuser' + queryString);
};



export const requestReadPartOffer = (id) => {
    return api.get(`/partoffer/${id}`);
};


